export default function () {
    const $reply = document.getElementsByClassName('comment-reply');

    if ($reply.length > 0) {
        let $parentInput = document.getElementById('comment_parent');
        let $form = document.querySelector("#commentform");

        let $replyContainer = $form.querySelectorAll(".comment-form-reply")[0];
        let $replyTextContainer = $replyContainer.querySelectorAll(".comment-form-reply-comment")[0];

        [].forEach.call($reply, (btn => {
            btn.addEventListener('click', function () {
                let $dataID = btn.attributes['data-id'].value;
                let $commentToReply = document.querySelector("#div-comment-" + $dataID);
                let $commentText = $commentToReply.querySelectorAll(".comment-content")[0].innerHTML;

                if (!$replyContainer.classList.contains("show")) {
                    $replyContainer.classList.add("show");
                }

                $replyTextContainer.innerHTML = $commentText;
                $parentInput.value = $dataID;
                window.scroll(0, $form.offsetTop - 200);
            });
        }));

        const $cancelReply = document.querySelector('#cancel-reply');

        if ($cancelReply) {
            $cancelReply.addEventListener('click', function () {
                $replyContainer.classList.remove("show");
                $parentInput.value = "";
            });
        }
    }
}
